import { useAppStore } from '@halo/chat-sdk-react';
import { Show } from '@chakra-ui/react';
import { useActionsStore } from '@/store/actions';
import { useCountries } from '@/scripts/hooks/useCountries';
import { useStaticAppStore } from '@/store/client';
import { ProfileEditDialog } from '../ProfileEditDialog';
import { ProfileDialog as ProfileDialog_ } from './Profile';

export function ProfileDialog() {
  const { user } = useAppStore();

  const { getUserProfiles } = useStaticAppStore();
  const { setProfileUser, profileUser } = useActionsStore();
  const { countryLabel } = useCountries(profileUser?.location || '');
  const refEffects = useRef<Record<string, () => void>>(undefined);

  const isMe = useMemo(() => {
    return user?.user_id === profileUser?.user_id;
  }, [user?.user_id, profileUser?.user_id]);

  const handleUpdateProfileUser = useCallback(async () => {
    refEffects.current?.removeListener?.();
    const { removeListener } = await getUserProfiles(user.user_id, setProfileUser);
    refEffects.current = { removeListener };
  }, [user?.user_id, getUserProfiles, setProfileUser]);

  return (
    <Show when={!!profileUser}>
      <ProfileDialog_
        user={profileUser!}
        isMe={isMe}
        handleUpdateProfileUser={handleUpdateProfileUser}
        countryLabel={countryLabel}
      />
      <ProfileEditDialog
        user={profileUser!}
        handleUpdateProfileUser={handleUpdateProfileUser}
        countryLabel={countryLabel}
      />
    </Show>
  );
}
